import React from 'react';

import MemoryApp from '../memoryGame/MemoryApp';

const GamesMemory = () => {
  return (
    <div>
        <MemoryApp />
    </div>
  )
}

export default GamesMemory;